export { Logger, StatusType, HandlerType } from './domain/logger';
export { datadogLogs } from './boot/logs.entry';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-logs/esm/index.js
// module id = 1226
// module chunks = 0